export default "__VITE_ASSET__BZXW$6di__"